import React from 'react';
import Page from "../component/Page/Page";
import DispositionForm from "./DispositionForm";

class DispositionFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    return (
        <Page title="Dados da disposição">
          <DispositionForm match={match} history={history}/>
        </Page>
    );
  }
}

export default DispositionFormPage;



// WEBPACK FOOTER //
// ./src/disposition/DispositionFormPage.js